import {
  REQUEST_RELATED_SAILINGS,
  RELATED_SAILINGS_ERROR,
  FINISHED_RELATED_SAILINGS_REQUESTS
} from '../actions/relatedSailings'

const initialState = {
  isLoading: false,
  hasErrors: false
}

const relatedSailings = (state = initialState, action) => {
  switch (action.type) {
    case RELATED_SAILINGS_ERROR:
      return Object.assign({}, state, {
        hasErrors: true,
        isLoading: false
      })
    case FINISHED_RELATED_SAILINGS_REQUESTS:
      return Object.assign({}, state, {
        isLoading: false
      })
    case REQUEST_RELATED_SAILINGS:
      return Object.assign({}, state, {
        isLoading: true
      })
    default:
      return state
  }
}

export default relatedSailings
